import { ArrowRight, Users, Building, Dumbbell, Target, Snowflake, TrendingUp, Shield, Clock } from "lucide-react";
import { Button } from "../ui/button";
import SectionLogo from "../SectionLogo";

const HERO_PILLS = [
  { id: "pain-relief", label: "Pain Relief Treatments", Icon: null },
  { id: "fat-reduction", label: "Fat Reduction Treatments", Icon: null },
  { id: "gym-partnerships", label: "Gym Partnerships", Icon: Dumbbell },
  { id: "events-teams", label: "Sports Teams", Icon: Users },
  { id: "corporate-wellness", label: "Corporate Wellness", Icon: Building },
  { id: "chiro-pt", label: "Chiropractors/Physical Therapists", Icon: Shield },
  { id: "races-track", label: "Races & Track Events", Icon: TrendingUp },
  { id: "baseball", label: "Baseball", Icon: Target },
];

const HERO_BADGES = [
  { Icon: Snowflake, label: "Mobile" },
  { Icon: Target, label: "Targeted" },
  { Icon: Shield, label: "No chamber" },
  { Icon: Clock, label: "No downtime" },
];

export const HeroSection = ({ scrollToSection }) => {
  return (
    <section className="relative flex items-center justify-center overflow-hidden pt-16 pb-8 md:pt-20 md:pb-12">
      <SectionLogo position="top-right" size="large" opacity={0.08} />
      <div className="absolute inset-0 bg-gradient-to-br from-[#0a0318] via-[#120525] to-[#0a0318]"></div>
      <div className="absolute top-20 left-10 w-96 h-96 bg-purple-800/20 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-amber-500/20 rounded-full blur-3xl animate-pulse"></div>

      <div className="container mx-auto px-4 pt-24 pb-4 relative z-10">
        <div className="max-w-5xl mx-auto">
          <div className="space-y-3 text-center">
            <img
              src="/images/imc-shield.png"
              alt="Ice Man Cryo Logo"
              className="w-36 h-36 md:w-64 md:h-64 object-contain mx-auto"
            />

            <h2 className="text-base md:text-xl font-semibold text-amber-400">Serving Metropolitan Atlanta</h2>

            <div className="space-y-1">
              <h1 className="text-3xl md:text-7xl font-bold text-white leading-tight">
                Freeze Pain.
                <span className="block bg-gradient-to-r from-cyan-400 via-purple-400 to-amber-400 bg-clip-text text-transparent">
                  Start Recovery.
                </span>
              </h1>
              <p className="text-base md:text-xl text-gray-300 leading-relaxed">
                Targeted cryotherapy for pain relief, recovery, and fat reduction.
              </p>
            </div>

            <Button
              size="lg"
              onClick={() => scrollToSection("booking")}
              className="bg-gradient-to-r from-amber-600 to-amber-500 hover:from-amber-700 hover:to-amber-600 text-white text-base md:text-lg px-8 py-4 md:px-10 md:py-6 rounded-xl shadow-lg shadow-amber-500/30 mx-auto"
              data-testid="hero-book-now"
            >
              Book Your Session Now <ArrowRight className="w-5 h-5 ml-2" />
            </Button>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-4">
              {HERO_PILLS.map((pill) => (
                <Button
                  key={pill.id}
                  variant="outline"
                  size="lg"
                  onClick={() => scrollToSection(pill.id)}
                  className="border border-amber-500/50 text-amber-400 hover:bg-amber-500/10 rounded-full py-3 md:py-4 text-xs md:text-sm"
                  data-testid={`hero-pill-${pill.id}`}
                >
                  {pill.Icon && <pill.Icon className="w-4 h-4 mr-1 hidden md:inline" />}
                  {pill.label}
                </Button>
              ))}
            </div>

            <div className="flex flex-wrap items-center justify-center gap-3 md:gap-6 pt-3 border-t border-amber-500/20">
              {HERO_BADGES.map((badge) => (
                <div key={badge.label} className="flex items-center gap-2">
                  <badge.Icon className="w-4 h-4 text-amber-400" />
                  <span className="text-white/70 text-sm">{badge.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
